import * as authStore from '@/modules/auth/auth.store';
import * as authResource from '@/modules/auth/auth.resource';

export function passwordLogin(email, password) {
  return new Promise((resolve, reject) => authResource
    .login(email, password)
    .then(({ data }) => {
      if (!data.token) {
        reject();
      }
      authStore.mutations.setToken(data.token);
      return resolve();
    })
    .catch(err => {
      authStore.mutations.clearToken();
      return reject(err);
    }));
}

export function sendNewPassword(email) {
  return new Promise((resolve, reject) => authResource
    .sendNewPassword({ to: email })
    .then(() => resolve())
    .catch(err => {
      reject(err);
    }));
}

export function register(registerInfo) {
  return new Promise((resolve, reject) => authResource
    .register(formatRegistrationData(registerInfo))
    .then(({ data }) => {
      authStore.mutations.setToken(data.token);
      return resolve();
    })
    .catch(err => {
      authStore.mutations.clearToken();
      return reject(err);
    }));
}

function formatRegistrationData(info) {
  return {
    name: info.first_name,
    last_name: info.last_name,
    email: info.email,
    password: info.password,
    password_confirmation: info.confirm_password,
    language: info.language,
    company: {
      company_name: info.company.name,
      vat: info.company.vat,
      country: info.company.country,
      state: info.company.state,
      city: info.company.city,
      zip_code: info.company.zip,
      address_1: info.company.first_address,
      address_2: info.company.second_address,
      plan: 1,
    },
  };
}
